<template>
  <div class="sitemap-page">
    <!-- Contenido principal -->
    <div class="main-content">
      <div class="content-card">
        <p class="intro-text">
          {{ t("siteMap.intro") }}
        </p>

        <!-- Secciones principales -->
        <section
          class="sitemap-section"
          aria-labelledby="main-title"
        >
          <h2
            id="main-title"
            class="section-title"
          >
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-star
            </v-icon>
            {{ t("siteMap.seccionesPrincipales") }}
          </h2>

          <nav
            class="link-grid"
            :aria-label="t('siteMap.seccionesPrincipales')"
          >
            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('home')"
            >
              <v-icon color="primary">mdi-home</v-icon>
              <span>{{ t("menu.principal") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('test')"
            >
              <v-icon color="primary">mdi-speedometer</v-icon>
              <span>{{ t("menu.empezarTest") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('historial')"
            >
              <v-icon color="primary">mdi-history</v-icon>
              <span>{{ t("menu.historial") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('mapa')"
            >
              <v-icon color="primary">mdi-map</v-icon>
              <span>{{ t("menu.verMapa") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('estadisticas')"
            >
              <v-icon color="primary">mdi-chart-box</v-icon>
              <span>{{ t("menu.estadisticas") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('datos')"
            >
              <v-icon color="primary">mdi-database</v-icon>
              <span>{{ t("menu.datosAbiertos") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('cnmcData')"
            >
              <v-icon color="primary">mdi-chart-areaspline</v-icon>
              <span>{{ t("menu.cnmcData") || "CNMC Data" }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>
          </nav>
        </section>

        <div class="section-divider" />

        <!-- Más información -->
        <section
          class="sitemap-section"
          aria-labelledby="info-title"
        >
          <h2
            id="info-title"
            class="section-title"
          >
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-information
            </v-icon>
            {{ t("siteMap.masInformacion") }}
          </h2>

          <nav
            class="link-grid"
            :aria-label="t('siteMap.masInformacion')"
          >
            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('servicios')"
            >
              <v-icon color="primary">mdi-cog-outline</v-icon>
              <span>{{ t("menu.servicios") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('faq')"
            >
              <v-icon color="primary">mdi-frequently-asked-questions</v-icon>
              <span>{{ t("menu.faq") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('apps')"
            >
              <v-icon color="primary">mdi-cellphone-arrow-down</v-icon>
              <span>{{ t("menu.appsMoviles") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('iframe')"
            >
              <v-icon color="primary">mdi-application-brackets-outline</v-icon>
              <span>{{ t("menu.iframe") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('medios')"
            >
              <v-icon color="primary">mdi-newspaper-variant-outline</v-icon>
              <span>{{ t("menu.medios") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('configuracion')"
            >
              <v-icon color="primary">mdi-cog</v-icon>
              <span>{{ t("menu.configuracion") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>
          </nav>
        </section>

        <div class="section-divider" />

        <!-- Legal y Footer -->
        <section
          class="sitemap-section"
          aria-labelledby="legal-title"
        >
          <h2
            id="legal-title"
            class="section-title"
          >
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-shield-check
            </v-icon>
            {{ t("siteMap.footer") }}
          </h2>

          <nav
            class="link-grid"
            :aria-label="t('siteMap.footer')"
          >
            <a
              href="#"
              class="site-link"
              @click.prevent="
                navigateTo('politicaPrivacidad', {
                  hash: '#aviso-legal-y-terminos-de-uso',
                })
              "
            >
              <v-icon color="primary">mdi-file-document-outline</v-icon>
              <span>{{ t("footer.avisoLegal") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="
                navigateTo('politicaPrivacidad', {
                  hash: '#politica-privacidad',
                })
              "
            >
              <v-icon color="primary">mdi-lock-outline</v-icon>
              <span>{{ t("footer.politicaPrivacidad") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('politicaCookies')"
            >
              <v-icon color="primary">mdi-cookie-outline</v-icon>
              <span>{{ t("footer.politicaCookies") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link"
              @click.prevent="navigateTo('accesibilidad')"
            >
              <v-icon color="primary">mdi-human-wheelchair</v-icon>
              <span>{{ t("footer.accesibilidad") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>

            <a
              href="#"
              class="site-link active"
              @click.prevent="navigateTo('mapaSitio')"
            >
              <v-icon color="primary">mdi-sitemap</v-icon>
              <span>{{ t("footer.mapaSitio") }}</span>
              <v-icon
                size="small"
                class="link-arrow"
              >mdi-chevron-right</v-icon>
            </a>
          </nav>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import { getLocaleFromRoute } from "@/router";

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

// Obtener locale actual
const currentLocale = computed(() => getLocaleFromRoute(route));

// Helper para navegar manteniendo el idioma
const navigateTo = (baseName, options = {}) => {
  const routeName = currentLocale.value === "en" ? `${baseName}-en` : baseName;
  router.push({ name: routeName, ...options });
};
</script>

<style scoped>
.sitemap-page {
  display: flex;
  flex-direction: column;
}

/* ===== Main Content ===== */
.main-content {
  padding: 16px 0 24px;
}

.content-card {
  background: linear-gradient(135deg, #f8fafc 0%, #fff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 28px;
}

.intro-text {
  font-size: 0.875rem;
  color: #475569;
  line-height: 1.7;
  margin-bottom: 24px;
}

/* ===== Sitemap Sections ===== */
.sitemap-section {
  margin-bottom: 8px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
}

.section-title .v-icon {
  opacity: 0.8;
}

/* ===== Divider ===== */
.section-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #e5e7eb, transparent);
  margin: 24px 0;
}

/* ===== Link Grid ===== */
.link-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 10px;
}

.site-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: linear-gradient(135deg, #fafbfc 0%, #f8f9fa 100%);
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  text-decoration: none;
  color: #475569;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.site-link:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-color: #e5e7eb;
  transform: translateX(2px);
}

.site-link:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.site-link.active {
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  border-color: #d6e9f8;
}

.site-link span {
  flex: 1;
}

.site-link .v-icon {
  opacity: 0.7;
}

.link-arrow {
  opacity: 0.4;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.site-link:hover .link-arrow {
  opacity: 0.7;
  transform: translateX(2px);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {

  .main-content {
    padding: 16px;
  }

  .content-card {
    padding: 20px;
  }
}

@media (max-width: 600px) {
  .link-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 0.9375rem;
  }

  .site-link {
    padding: 10px 12px;
    font-size: 0.8125rem;
  }

  .content-card {
    padding: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .site-link,
  .link-arrow {
    transition: none;
  }

  .site-link:hover {
    transform: none;
  }

  .site-link:hover .link-arrow {
    transform: none;
  }
}
</style>
